export enum RoundFormState {
  EMPTY,
  CONNECT_WALLET,
  LOADING,
  KYC,
  WHITELISTING,
  CONTRIBUTION,
  ERROR,
}
